module.exports = __webpack_public_path__ + "img/candidate_chosen_placeholder.c390d492.png";